import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import React, { useEffect } from 'react';
import cityUpgrades from '../../config/cityUpgrades';
import Form from '../Form';
import FormSelect from '../FormSelect';

const CitySearch = ({ onQuery, onSortBy, onNumberOfBlocks, onUpgrade }) => {
  const formSchema = yup.object().shape({
    sortBy: yup.string(),
    numberOfBlocks: yup.string(),
    upgrade: yup.string(),
    query: yup.string(),
  });

  const form = useForm({
    defaultValues: {
      sortBy: 'mint_date',
      numberOfBlocks: '',
      upgrade: '',
      query: '',
    },
    resolver: yupResolver(formSchema),
  });

  const query = form.watch('query');
  const sortBy = form.watch('sortBy');
  const numberOfBlocks = form.watch('numberOfBlocks');
  const upgrade = form.watch('upgrade');
  useEffect(() => {
    onSortBy(sortBy);
  }, [sortBy]);

  useEffect(() => {
    onQuery(query);
  }, [query]);

  useEffect(() => {
    onNumberOfBlocks(numberOfBlocks);
  }, [numberOfBlocks]);

  useEffect(() => {
    onUpgrade(upgrade);
  }, [upgrade]);

  return (
    <div className='lg:flex lg:justify-end'>
      <Form form={form} className='flex flex-col lg:flex-row gap-3'>
        {/* <FormInput name='query' placeholder='Search cities' className='!bg-gray-900' /> */}
        <FormSelect
          name='sortBy'
          placeholder='Sort by'
          className='!bg-gray-900'
          options={[
            { value: 'mint_date', label: 'Mint Date' },
            { value: 'population', label: 'Population' },
            { value: 'rarity_score', label: 'Rarity Score' },
          ]}
        />
        <FormSelect
          name='numberOfBlocks'
          placeholder='Filter by # of blocks'
          className='!bg-gray-900 !min-w-[200px]'
          options={[
            { value: '', label: 'All' },
            { value: '9', label: '9' },
            { value: '8', label: '8' },
            { value: '7', label: '7' },
            { value: '6', label: '6' },
            { value: '5', label: '5' },
            { value: '4', label: '4' },
            { value: '3', label: '3' },
            { value: '2', label: '2' },
            { value: '1', label: '1' },
            { value: '0', label: '0' },
          ]}
        />
        <FormSelect
          name='upgrade'
          placeholder='Filter by Upgrade'
          className='!bg-gray-900 !min-w-[200px]'
          options={[{ value: '', label: 'All' }, ...cityUpgrades.map((upgrade) => ({ value: upgrade.name, label: upgrade.name }))]}
        />
      </Form>
    </div>
  );
};

export default CitySearch;
